import React from 'react';
import {CCardText, CCardTitle} from '@coreui/react';

const CardMessage = (props: any) => {
  const {messageTitle, messageText, title, message, componentKey} = props;
  const itemsToRender = [];
  const renderMessage = messageText ? messageText : message;
  const renderTitle = messageTitle ? messageTitle : title;
  if (renderTitle) {
    itemsToRender.push(
      <CCardTitle key={`${componentKey}-cardmessagetitle`} className="mb-3">
        {renderTitle}
      </CCardTitle>
    );
  }
  if (renderMessage) {
    itemsToRender.push(
      <CCardText key={`${componentKey}-cardmessagetext`} className="mb-3">
        {renderMessage}
      </CCardText>
    );
  }
  return <span>{itemsToRender}</span>;
};
export default CardMessage;
